import { createAsyncThunk } from '@reduxjs/toolkit';
import { generateFeed } from '../../../api/feeds';
import { routes } from '../../../constants/RouterPath';
import { createRequest } from '../../../helpers/api/createRequest';
import { Thunk } from '../../../helpers/redux/Thunk';
import { history } from '../../../store/history';
import { TypesIcon } from '../../../types/TypesIcon';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { addNotification } from '../../notifications';

export const GENERATE_FEED = 'feeds/getFeed';

const onSuccess = (): Thunk => dispatch => {
    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Фид отправлен в очередь на генерацию!',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));

    history.push(routes.feeds);
};

export const generateFeedThunk = createAsyncThunk(
    GENERATE_FEED,
    createRequest({
        type: GENERATE_FEED,
        loader: async (id: number) => generateFeed(id),
        onSuccess,
    }),
);
